import React from 'react'

const useSwitch = () => {
    const [value, setValue] = React.useState<boolean>(true)

    const handleChange = (enabled: boolean) => {
        setValue(enabled)
    }

    return {
        value: value,
        onChange: handleChange,
    }
}

export default useSwitch
